export const LOADING_START = 'LOADING_START';
export const LOADING_FINISH = 'LOADING_FINISH';
export const GET_SUBJECTS_CATEGORIES = 'GET_SUBJECTS_CATEGORIES';
